import React from 'react';
import { Global, css } from '@emotion/react';

const globalStyle = (theme) => css`
  html,
  body {
    height: 100%;
    width: 100%;
    line-height: 1.5;
  }

  body {
    font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
    background-color: ${theme.palette.background.paper};
  }

  body.fontLoaded {
    font-family: 'Inter', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  }

  p,
  label {
    margin: 0;
    line-height: 1.5em;
  }

  input,
  select,
  button {
    font-family: inherit;
    font-size: inherit;
  }

  .icon {
    width: 1.5rem;
    height: 1.5rem;
  }
`;

const GlobalStyle = () => <Global styles={globalStyle} />;
export default GlobalStyle;
